import { API_URL } from '../../../app-config/constants';
import { get as g } from '../request';

const RESOURCE = `${API_URL}/users/relationship`;

export type UserRelationshipType =
    | 'NONE'
    | 'DIRECT_MANAGER'
    | 'INDIRECT_MANAGER'
    | 'DIRECT_REPORT'
    | 'INDIRECT_REPORT'
    | 'SIBLING'
    | 'SELF';

export interface UserRelationshipDto {
    pair: [{ userId: string; level: number }, { userId: string; level: number }];
    relationship: UserRelationshipType;
}

get.operation = 'READ';
get.idFrom = 'ARGS';
export function get(idOfA: string, idOfB: string) {
    return g<UserRelationshipDto>(`${RESOURCE}/${idOfA}/${idOfB}`);
}
